import iconArrow from './iconArrow'
import iconBdArrow from './iconBdArrow'
import iconBdFilledArrow from './iconBdFilledArrow'
import iconFilledArrow from './iconFilledArrow'
import iconLine from './iconLine'
import iconBdDashedArrow from './iconBdDashedArrow'
import iconDashedArrow from './iconDashedArrow'
import iconEye from './iconEye'

export default {
  iconArrow,
  iconBdArrow,
  iconBdFilledArrow,
  iconFilledArrow,
  iconLine,
  iconBdDashedArrow,
  iconDashedArrow,
  iconEye
}



// WEBPACK FOOTER //
// ./src/components/icons/schema/index.js